import { makeRequestAxios } from '../state/_utils/requestAxios.mjs';

//This class is mainly for connecting to the guide api
//Other services have been made for each major module
//to call services provided by guide api.
//See ActionService for an example
//
//Please try not to clutter this class up with more endpoint calls
//create a new class and use the GuideApiService.makeRequest function
export class GuideApiService {
  
  static token = '';
  static baseUrl = '';
  static user = null;
  static uuid = null;
  static guide = null;
  static client = null;
  static lead = null;
  static rawAnswers = null;

  static useUser(user) {
    this.user = user;
    this.uuid = user.uuid;
  }

  static useGuide(guide) {
    this.guide = guide;
  }

  static useClient(client) {
    this.client = client;
  }

  static useLead(lead) {
    this.lead = lead;
  }

  static useAnswers(answers) {
    this.rawAnswers = answers;
  }

  static generateAnswersMap(){
    const output = {};
    if(!Array.isArray(this.rawAnswers)) return this.rawAnswers;
    this.rawAnswers.forEach(answer => {
      output[answer.appkey] = answer.text || answer.value;
    });
    return output;
  }

  static transformValuesInObject(obj) {
    for(let key in obj){
      obj[key] = this.transformValueWithPlaceholders(obj[key]);
    }
    return obj;
  }

  static transformValueWithPlaceholders(value) {
    if(Array.isArray(value)) return value.map(e => this.transformValueWithPlaceholders(e));
    else if(typeof value == 'object') return this.transformValuesInObject(value);
    else if(typeof value != 'string') return value;
    try{
      const result = new Function('uuid', 'user', 'client', 'guide', 'lead', 'answers', `return \`${value}\`;`);
      return result(this.uuid, this.user, this.client, this.guide, this.lead, this.generateAnswersMap());
    }catch(e){
      console.log('transform error', e);
      return value;
    }
  }

  static convertHeaders(headers) {
    const result = {};
    if(Array.isArray(headers)){
      headers.forEach(e=>{
        result[e.name] = e.value;
      });
      return result;
    }
    return headers;
  }
  
  /**
  * Get cognito access token
  * Pulls configuration from guide.attributes.dialogueApiConfig
  * Will set a global baseUrl and token to be used in other calls
  * 
  * @param {Object} dialogueApiConfig - The config object that should be stored in client.attributes
  
  * @returns {Promise} - The promise that resolves to the response of the action.
  */
  static async authenicate(dialogueApiConfig) {
    const { cognitoUrl, headers, body, url } = dialogueApiConfig;
    try{
      const authResponse = await makeRequestAxios('POST', cognitoUrl, body, this.convertHeaders(headers));
      this.token = authResponse.access_token;
      this.baseUrl = url;
    }catch(e){
      console.log('GuideApiService authenicate error', e);
    }
  }
  
  /**
  * Make header object with cognito token
  * 
  
  * @returns {Object} - A key/value map of headers
  */
  static async makeHeaders(uuid){
    if(!this.token) {
      try{
        if( window?.ignite?.userService?.getGuideAttributes ) {
          const guideAttributes = await window.ignite.userService.getGuideAttributes();
          await this.authenicate(guideAttributes?.dialogueApiConfig);
        } else throw new Error('No getGuideAttributes');
      }catch(e){
        console.log('GuideApiService auth failure', e);
        throw new Error('No Auth Token found');
      }
    }
    const output = {
      Authorization: `Bearer ${this.token}`,
      'Content-Type': 'application/json'
    };

    if(uuid) output.uuid = uuid;
    return output;
  }
  
  /**
  * Make a request to the guide api
  * The authenicate() function must be called before using this
  * headers are automatically attached
  * an error will occur if no token is provided
  * 
  * @param {string} method - POST, GET, PUT, DELETE
  * @param {string} endpoint - The endpoint to add to the base url
  * @param {string} body - The body to send with the api call
  
  * @returns {Promise} - The promise that resolves to the response of the action.
  */
  static async makeRequest(method, endpoint, body, uuid) {
    return makeRequestAxios(method, `${this.baseUrl}${endpoint}`, body, await this.makeHeaders(uuid));
  }
  
}

// Export the class
export default GuideApiService;